<template>
  <div style="width: 96%;margin: auto; padding: 10px;">
    <div>
      <el-form ref="form" :inline="true" :model="form" label-width="80px">
        <el-form-item label="会员ID">
          <el-input v-model="form.userId"></el-input>
        </el-form-item>
        <el-form-item label="会员名称">
          <el-input v-model="form.userName"></el-input>
        </el-form-item>
        <el-form-item label="厅房名称">
          <el-input v-model="form.deptName"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button style="margin-left: 10px;" type="primary" @click="search">查询</el-button>
          <el-button type="reset" @click="reset">重置</el-button>
          <el-button type="warning" @click="back">返回</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div style="width: 96%;margin: auto;padding: 10px;color: red;">
      规则说明：单厅房单人单周>=5次
    </div>
    <div style="width: 96%;margin: 10px auto;padding: 10px;margin-left: 30px;">
      <span class="text-gradient1">商圈预警</span>
      <div class="mt-1">
        <el-table
            :data="tableStoreDataOne"
            stripe
            style="width: 100%">
          <el-table-column
              prop="hyid"
              label="会员ID"
              width="180">
          </el-table-column>
          <el-table-column
              prop="hyName"
              label="会员名称"
              width="180">
          </el-table-column>
          <el-table-column
              prop="deptName"
              label="厅房名称"
              width="180">
          </el-table-column>
          <el-table-column
              prop="startTime"
              label="开始时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="endTime"
              label="结束时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="num"
              label="次数"
              width="180">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div style="width: 96%;margin: auto;padding: 10px;color: red;">
      规则说明：用户当周获得该厅房积分超过1000
    </div>
    <div style="width: 96%;margin: 10px auto;padding: 10px;margin-left: 30px;">
      <span class="text-gradient1">商圈预警</span>
      <div class="mt-1">
        <el-table
            :data="tableStoreDataTwo"
            stripe
            style="width: 100%">
          <el-table-column
              prop="hyid"
              label="会员ID"
              width="180">
          </el-table-column>
          <el-table-column
              prop="hyName"
              label="会员名称"
              width="180">
          </el-table-column>
          <el-table-column
              prop="deptName"
              label="厅房名称"
              width="180">
          </el-table-column>
          <el-table-column
              prop="startTime"
              label="开始时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="endTime"
              label="结束时间"
              width="180">
          </el-table-column>
          <el-table-column
              prop="num"
              label="获取积分数"
              width="180">
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>

</template>

<script>

import AlarmOrderApi from "../../api/alarm/order/AlarmOrderApi";
import { default as commonIn } from '@/util/common'
export default {
  name: "tradingArea",
  props: {
    item: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      optionStore: [],
      form: {
        userId: '',
        userName: '',
        deptName: ''
      },
      tableStoreDataOne: [],
      tableStoreDataTwo: [],
      startDate: '',
      endDate: ''
    }
  },
  created() {

  },
  mounted() {
    let createDate = '2022-11-07 00:00:00' //commonIn.timeFormatSeconds(this.item.createDate)
    let params = {
      createDate: createDate
    }
    this.getTradingAreaDetail(params)
  },
  methods: {
    // 获取商圈预警详情
    getTradingAreaDetail(params) {
      console.log(params)
      let that = this

      AlarmOrderApi.getTradingAreaDetail(params).then(res => {
        console.log(res.data)
        res = res.data
        if (res.code == 200) {
          let dataIn = res.data;
          let arrOne = []
          let arrTwo = []
          if (dataIn.length > 0) {
            dataIn.map(item => {
              if (item.type == 1) {
                arrOne.push(item)
              } else {
                arrTwo.push(item)
              }
            })

            that.tableStoreDataOne = arrOne
            that.tableStoreDataTwo = arrTwo
          }
        }
      })
    },
    search() {
      let createDate = '2022-11-07 00:00:00'//commonIn.timeFormatSeconds(this.item.createDate)
      let params = {
        userId: parseInt(this.form.userId),
        userName: this.form.userName,
        deptName: this.form.deptName,
        createDate: createDate
      }

      this.getTradingAreaDetail(params)
    },
    reset() {
      this.form.resetFields()
    },
    back() {
      if (this.turnType == 1) {
        this.$emit("addCallbackTask")
      } else {
        this.$emit("back")
      }
    }
  }
}
</script>

<style scoped>
.text-gradient1 {
  background-image: linear-gradient(to right, #ffd666, #ad6800);
  -webkit-background-clip: text;
  color: transparent;
  font-weight: 700;
  font-size: 17px;
}
</style>